export enum LsidIdentityType {
  Session = 'SESSION',
  User = 'USER',
  Onelogin = 'ONE_LOGIN',
  Unknown = 'UNKNOWN',
}

export const isSessionIdentity = (identity: any): boolean => {
  return identity?.sub?.startsWith('Session:') || false;
};

export const isUserIdentity = (identity: any): boolean => {
  return identity?.sub?.startsWith('User:') || false;
};

export const isOneLoginIdentity = (identity: any): boolean => {
  return identity?.sub?.startsWith('FireplaceOnelogin:') || false;
};

export const hasNuOrderGrant = (identity: any): boolean => {
  return !!identity?.grants?.user?.nuorder;
};

export const getIdentityType = (identity: any): LsidIdentityType => {
  if (isSessionIdentity(identity)) {
    return LsidIdentityType.Session;
  }

  if (isUserIdentity(identity)) {
    return LsidIdentityType.User;
  }

  if (isOneLoginIdentity(identity)) {
    return LsidIdentityType.Onelogin;
  }

  return LsidIdentityType.Unknown;
};
